var map = {
	"./settings": 5541,
	"./settings.development": 5470,
	"./settings.development.json": 5470,
	"./settings.json": 5541,
	"./settings.local": 2096,
	"./settings.local.json": 2096,
	"./settings.production": 2742,
	"./settings.production.json": 2742,
	"./settings.test": 177,
	"./settings.test.json": 177
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5351;